import { FC } from 'react'
import { ICategory } from 'types/common'
import { ALL_CATEGORIES } from 'shared/constants'
import styles from './styles'

type PageHeaderProps = {
  title?: string
  description?: string
  categories?: ICategory[]
  activeCategory?: string
  onChangeActiveCategory?: (category: string) => void
  categoryTags?: string[]
}

const PageHeader: FC<PageHeaderProps> = ({
  title,
  description,
  categories,
  categoryTags,
  activeCategory,
  onChangeActiveCategory,
}) => {
  return (
    <>
      {!!title && <h1 className="title">{title}</h1>}
      {!!categoryTags?.length && (
        <div className="cats">
          {categoryTags.map((category, index) => (
            <div
              className="cat"
              key={index}
            >{`#${category}`}</div>
          ))}
        </div>
      )}
      {!!description && <div className="description">{description}</div>}
      {!!categories?.length && (
        <div className="cats-filter">
          {[ALL_CATEGORIES, ...categories].map((category, index) => (
            <div
              className={`cat-filter ${activeCategory === category.cat_value && 'cat-filter-active'}`}
              key={index}
              onClick={() => {
                onChangeActiveCategory?.(category.cat_value)
              }}
            >
              {category.name}
            </div>
          ))}
        </div>
      )}
      <style jsx>{styles}</style>
    </>
  )
}

export default PageHeader
